import { render, staticRenderFns } from "./SwiperComponent.vue?vue&type=template&id=025d2e0e&scoped=true&"
import script from "./SwiperComponent.vue?vue&type=script&lang=js&"
export * from "./SwiperComponent.vue?vue&type=script&lang=js&"
import style0 from "./SwiperComponent.vue?vue&type=style&index=0&id=025d2e0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025d2e0e",
  null
  
)

export default component.exports